<template>
  <div class="request-error" v-bind:class="{ active: current }">
    {{error ? 'Erro ao reenviar.' : 'Não foi possível salvar suas informações.'}}
    <a class="btn-action" v-show="!error" v-on:click.stop.prevent="resend" href="">
      {{!resubmitting ? 'Reenviar' : (!error ? 'Enviando...' : '')}}
    </a>
    <a class="btn-action" v-show="error" v-on:click.stop.prevent="sendemail" href="">
      Enviar resultado por email
    </a>
    <a href="" class="btn-close">x</a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        resubmitting: false,
        error: false
      }
    },
    computed: { 
      current() {
        return this.$store.state.requestError;
      },
      sendError() {
        return this.error;
      }
    },
    methods: {
      sendemail() {
        const data = {
          cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
          experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
          empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
          tecnologia_digital: this.$store.state.tecnologia_digital,
          agilidade_operacional: this.$store.state.agilidade_operacional,
          test_results: this.$store.state.test_results
        }

        let link = 'mailto:premium@transformacaodigital.com';
        link += '?subject=' + encodeURIComponent('RESULTADO TD SCORE');
        link += '&body=' + encodeURIComponent('ID: ' + this.$store.state.userid);
        link += encodeURIComponent('\nNome: ' + this.$store.state.username);
        link += encodeURIComponent('\nResultado: ' + btoa(JSON.stringify(data)));
        window.location = link;

        this.$store.commit('REQUEST_ERROR', false);
      },
      resend() {
        if (this.resubmitting) return;
        this.resubmitting = true;

        if (this.$store.state.userid) {

          this.error = true

          const data = {
            cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
            experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
            empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
            tecnologia_digital: this.$store.state.tecnologia_digital,
            agilidade_operacional: this.$store.state.agilidade_operacional,
            test_results: this.$store.state.test_results
          }

          try {
            this.$http.post('/api/user/' + this.$store.state.userid + '/' + this.$store.state.usercode, data)
            .then(response => {
              if (response.body && response.body.success) {                
                //this.$store.commit('REQUEST_ERROR', false);
                this.error = true
              } else {
                this.error = true
              }
            }, response => {
              this.error = true
            });
          } catch(e) {
            this.error = true
          }
          
        } else {
          this.error = true
        }
      }
    }
  }
</script>

<style scoped>
  .request-error {
    position: fixed;
    top: -50px;
    left: 0;
    right: 0;
    height: 50px;
    background-color: #d84315;
    color: #fff;
    display: block;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }

  .request-error.active {
    transition: top .5s ease;
    top: 0px;
  }

  .request-error .btn-action {
    color: #fff;
    margin-left: 10px;
  }

  .request-error .btn-close {
    position: absolute;
    top: 5px;
    right: 20px;
    font-size: 30px;
    color: #fff;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequestError.vue